import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import PublisherCard from '../../components/publisherCard';
import usePublisher from '../../../store/models/publisher/usePublisher';
import * as styles from './styles';

function Trending({ onSync, onShare }) {
    const { popularNowPublishers } = usePublisher();

    function renderSectionHeader() {
        return (
            <Box sx={styles.sectionHeader}>
                <Box>
                    <Typography sx={styles.eyebrow}>Popular right now</Typography>
                    <Typography variant="h2" sx={styles.title}>
                        Trending picks near{' '}
                        <Box component="span" sx={styles.gradientText}>you</Box>
                    </Typography>
                    <Typography sx={styles.subtitle}>
                        Balanced 50/50 between live popularity and your detected region.
                    </Typography>
                </Box>
            </Box>
        );
    }

    function renderGrid() {
        return (
            <Box sx={styles.grid}>
                {popularNowPublishers.map((publisher) => (
                    <PublisherCard
                        key={publisher.id}
                        publisher={publisher}
                        onSync={onSync}
                        onShare={onShare}
                    />
                ))}
            </Box>
        );
    }

    if (!popularNowPublishers.length) return null;

    return (
        <Box component="section" sx={styles.section}>
            <Container maxWidth="xl">
                {renderSectionHeader()}
                {renderGrid()}
            </Container>
        </Box>
    );
}

export default Trending;
